import { RouteObject } from 'react-router';

import { ShopsPage } from './features/shops/pages/ShopsPage';
import { ShopContainer } from './features/shops/containers/ShopContainer';
import { CategoriesContainer } from './features/categories/containers/CategoriesContainer';
import AIFeature from './features/ai-assistant';
import Attributes from './features/attributes';
import VisitorsFeature from '../crm/features/visitors';
import OrdersFeature from '../crm/features/orders';
import Settings from './features/setting';
import Support from './features/support';
import LegalFeature from './features/legal';
import PromocodeFeature from './features/promocodes';
import FeedFeature from './features/feed';
import PaymentFeature from './features/payments';
import IntegrationEmailFeature from './features/intergration-email';
import BotSettingFeature from './features/bot';
import BannerFeature from './features/banners';
import ApiKeysFeature from './features/api-keys';
import { ProductsContainer } from './features/products/containers/ProductsContainer';
import { ProductCreateContainer } from './features/products/containers/ProductCreateContainer';
import { ProductEditContainer } from './features/products/containers/ProductEditContainer';
import { bannerExtraRoutes } from './features/banners/routes';
import { SHOP_CURRENT_ROUTE } from './utils/constants';
import { ShopCreateContainer } from './features/shops/containers/ShopCreateContainer';

const routes: RouteObject[] = [
    {
        path: 'shops',
        element: <ShopsPage />,
        children: [
            {
                path: 'create',
                element: <ShopCreateContainer />,
            },
        ],
    },
    {
        path: `${SHOP_CURRENT_ROUTE}`,
        element: <ShopContainer />,
        children: [
            {
                path: ':type',
                element: <ProductsContainer />,
            },
            ...BannerFeature.routes,
            ...OrdersFeature.routes,
            ...VisitorsFeature.routes,
            {
                path: 'categories',
                element: <CategoriesContainer />,
            },
            ...Attributes.routes,
            ...Settings.routes,
        ],
    },
    ...LegalFeature.routes,
    ...Support.routes,
    ...PaymentFeature.routes,
    ...FeedFeature.routes,
    ...AIFeature.routes,
    ...BotSettingFeature.routes,
    ...IntegrationEmailFeature.routes,
    ...PromocodeFeature.routes,
    ...bannerExtraRoutes,
    {
        path: `${SHOP_CURRENT_ROUTE}/:type-create`,
        element: <ProductCreateContainer />,
    },
    {
        path: `${SHOP_CURRENT_ROUTE}/:type-edit/:productId`,
        element: <ProductEditContainer />,
    },
    ...ApiKeysFeature.routes,
];
export default routes;
